module.exports = "https://www.gc-pro.gnp.com.mx/2fca110b6eaa6519a765d4e265e8d537.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icondanios.svg
// module id = 8137
// module chunks = 0